import React, { useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import usePersistedFilters from "../hooks/usePersistedFilters";
import usePersistedPageSize from "../hooks/usePersistedPageSize";
import AddressesAllMissingFieldsFilters from "../components/Reports/AddressesAllMissingFields/AddressesAllMissingFieldsFilters";
import AddressesAllMissingFieldsButtons from "../components/Reports/AddressesAllMissingFields/AddressesAllMissingFieldsButtons";
import AddressesAllMissingFieldsTable from "../components/Reports/AddressesAllMissingFields/AddressesAllMissingFieldsTable";
import PaginationComponent from "../components/PaginationComponent";
import ReportIcon from "../assets/images/emerging_market_solutions_rgb_red.svg";
import "../assets/styles/addresses.scss";
import api from "../services/httpClient";

const ReportsAddressesAllMissingFields = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = usePersistedPageSize("addressesAllMissingFields", 20);
  const { filters, handleFilterChange, clearFilters, hasActiveFilters } = usePersistedFilters("addressesAllMissingFields", { missingFieldsMatchAll: false });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [sortConfig, setSortConfig] = useState({ key: "Postcode", direction: "asc" });
  const [selectedIds, setSelectedIds] = useState([]);

  const handleSelectionChange = (newSelectedIds) => {
    setSelectedIds(newSelectedIds);
  };

  const [data, setData] = useState({
    items: [],
    totalRecords: 0,
    totalPages: 0,
    pageNumber: 1,
    pageSize: itemsPerPage,
  });

  const fetchData = React.useCallback(
    async (
      pageNumber = currentPage,
      pageSize = itemsPerPage,
      filtersToApply = appliedFilters,
      sortConfigToApply = sortConfig
    ) => {
      try {
        const response = await api.get(`/Address/List`, {
          params: {
            pageNumber,
            pageSize,
            SortBy: sortConfigToApply.key,
            SortDirection: sortConfigToApply.direction,
            missingFieldsMatchAll: false,
            ...filtersToApply,
          },
        });

        setData({
          items: Array.isArray(response.data.items) ? response.data.items : [],
          totalRecords: response.data.totalRecords || 0,
          totalPages: response.data.totalPages || 0,
          pageNumber: response.data.pageNumber || 1,
          pageSize: response.data.pageSize || itemsPerPage,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        setData({
          items: [],
          totalRecords: 0,
          totalPages: 0,
          pageNumber: 1,
          pageSize: itemsPerPage,
        });
      }
    },
    [currentPage, itemsPerPage, appliedFilters, sortConfig]
  );

  React.useEffect(() => {
    fetchData();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const handleImmediateFilterChange = (field, value) => {
    handleFilterChange(field, value);
    const updatedFilters = { ...filters, [field]: value };
    setAppliedFilters(updatedFilters);
    fetchData(1, itemsPerPage, updatedFilters);
    setCurrentPage(1);
  };

  const handleSearch = () => {
    console.log("Search triggered with filters:", filters);
    setAppliedFilters(filters);
    fetchData(1, itemsPerPage, filters);
    setCurrentPage(1);
  };

  const handleSortChange = (newSortConfig) => {
    setSortConfig(newSortConfig);
    fetchData(currentPage, itemsPerPage, appliedFilters, newSortConfig);
  };

  return (
    <div className="addresses-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <img
              src={ReportIcon}
              alt="Reports"
              style={{ width: "30px", height: "30px" }}
            />
          </Col>
          <Col>
            <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Raport adresów z pustymi polami
            </h3>
          </Col>
          <Col xs="auto">
            <AddressesAllMissingFieldsButtons onSearch={handleSearch} filters={filters} selectedIds={selectedIds} />
          </Col>
        </Row>
        <Row className="align-items-center mb-4">
          <Col xs="auto">
            <AddressesAllMissingFieldsFilters onFilterChange={handleFilterChange} onSearch={handleSearch} onImmediateFilterChange={handleImmediateFilterChange} filters={filters} />
          </Col>
          <Col className="flex-grow-1" />
        </Row>
        <Row className="justify-content-end mb-3">
          <Col xs="auto">
            <Button
              variant={hasActiveFilters ? "success" : "outline-secondary"}
              size="sm"
              className="me-3"
              onClick={() => { clearFilters(); setAppliedFilters({}); fetchData(1, itemsPerPage, {}); setCurrentPage(1); }}
            >
              Wyczyść filtry
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <AddressesAllMissingFieldsTable
              data={data.items}
              onSortChange={handleSortChange}
              onSelectionChange={handleSelectionChange}
            />
          </Col>
        </Row>
        <Row className="align-items-center mt-4">
          <PaginationComponent
            itemsPerPage={data.pageSize}
            dataCount={data.items.length}
            totalCount={data.totalRecords}
            totalPages={data.totalPages}
            pageNumber={currentPage}
            onPageChange={(page) => {
              setCurrentPage(page);
              fetchData(page, itemsPerPage);
            }}
            onItemsPerPageChange={(pageSize) => {
              const size = Number(pageSize);
              setItemsPerPage(size);
              setCurrentPage(1);
              fetchData(1, size);
            }}
            itemsPerPageOptions={[20, 100, 500, 1000, 5000]}
          />
        </Row>
      </Container>
    </div>
  );
};

export default ReportsAddressesAllMissingFields;

